import React, { FC } from 'react';
import { CollapsibleBase, CollapsibleBaseClassNames } from './CollapsibleBase';
import { twMerge } from '@shared/utils/twMerge';

export type InnerCollapsibleProps = {
  title: React.ReactNode;
  children: React.ReactNode;

  /** Slight visual indent for hierarchy. */
  indent?: boolean;
  /** Optional subtle guide line at the left. */
  showGuideLine?: boolean;

  /** Chevron side. */
  iconPosition?: 'left' | 'right';

  /** Control/open behavior. */
  open?: boolean;
  defaultOpen?: boolean;
  onToggle?: (o: boolean) => void;

  /** Re-measure trigger. */
  resize?: number | string;

  /** Extra class hooks. */
  classNames?: Partial<CollapsibleBaseClassNames>;
  headerBg?: string; // e.g. 'bg-spanishGray'
  bodyBg?: string; // e.g. 'bg-white'
};

export const InnerCollapsible: FC<InnerCollapsibleProps> = ({
  title,
  children,
  indent = true,
  showGuideLine = false,
  iconPosition = 'left',
  open,
  defaultOpen,
  onToggle,
  resize,
  classNames = {},
  headerBg = '', // NEW
  bodyBg = '', // NEW
}) => {
  return (
    <CollapsibleBase
      iconPosition={iconPosition}
      open={open}
      defaultOpen={defaultOpen}
      onToggle={onToggle}
      resize={resize}
      classNames={{
        // Tight nesting: no top margin, no outer rounding/shadow by default
        outer: twMerge(classNames.outer),

        container: twMerge('mt-0', classNames.container),

        header: twMerge(
          'h-10 pr-2',
          indent ? 'pl-6' : 'pl-7',
          showGuideLine ? 'border-l border-waterLight' : '',
          headerBg,
          classNames.header
        ),

        content: twMerge(classNames.content),

        body: twMerge('p-2', bodyBg, classNames.body),

        iconBtn: twMerge(classNames.iconBtn),
        icon: twMerge(classNames.icon),
      }}
      label={<div className="flex w-full items-center gap-2">{title}</div>}
    >
      {children}
    </CollapsibleBase>
  );
};
